import { render, staticRenderFns } from "./ReductionSection.vue?vue&type=template&id=7d944c24&scoped=true&"
import script from "./ReductionSection.vue?vue&type=script&lang=js&"
export * from "./ReductionSection.vue?vue&type=script&lang=js&"
import style0 from "./ReductionSection.vue?vue&type=style&index=0&id=7d944c24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d944c24",
  null
  
)

export default component.exports